// extracted by mini-css-extract-plugin
export var black = "_3r-6";
export var brand = "_3r-1";
export var ddefault = "_3r-0";
export var error = "_3r-3";
export var gray = "_3r-2";
export var highContrast = "_3r-8";
export var outline = "_3r-7";
export var success = "_3r-5";
export var warning = "_3r-4";